import playlistService from '../../services/playlistService';

// State
const playlistState = {
  playlist: null
};

// Getters
const playlistGetters = {
  playlist(state) {
    return state.playlist;
  },
  items(state) {
    return state.playlist ? state.playlist.items : [];
  },
  itemIds(state, getters) {
    return getters.items ? getters.items.map(item => item._id) : [];
  },
  hasItems(state, getters) {
    return getters.items ? getters.items.length > 0 : false;
  }
};

// Mutations
const mutations = {
  setPlaylist(state, playlist) {
    state.playlist = playlist;
  },
  setPlaylistItems(state, items) {
    state.playlist.items = items;
  },
  removeItemAt(state, index) {
    state.playlist.items.splice(index, 1);
  },
  addItemAt(state, { item, index }) {
    state.playlist.items.splice(index, 0, item);
  }
};

// Actions
const actions = {
  async getLastUpdatedPlaylist({ commit }) {
    const response = await playlistService.getList({ sortBy: 'lastUpdated', sortOrder: 'desc', limit: 1 });
    const playlist = response.data.playlists.length > 0 ? response.data.playlists[0] : null;
    commit('setPlaylist', playlist);
    return playlist;
  },
  async setPlaylist({ commit }, playlist) {
    commit('setPlaylist', playlist);
    return playlist;
  },
  async setPlaylistItems({ commit }, items) {
    commit('setPlaylistItems', items);
    return items;
  },
  async removeItemAt({ commit, state }, index) {
    const item = state.playlist.items[index];
    commit('removeItemAt', index);
    try {
      await playlistService.update(state.playlist._id, state.playlist);
      return item;
    } catch (e) {
      // Revert operation
      commit('addItemAt', { item, index });
      throw e;
    }
  },
  async addItemAt({ commit, state }, { item, index }) {
    commit('addItemAt', { item, index });
    try {
      await playlistService.update(state.playlist._id, state.playlist);
      return item;
    } catch (e) {
      // Revert operation
      commit('removeItemAt', index);
      throw e;
    }
  },
  async removeItem({ dispatch, state }, itemId) {
    const itemIndex = state.playlist.items.findIndex(elem => elem._id === itemId);
    if (itemIndex >= 0) {
      return dispatch('removeItemAt', itemIndex);
    } else {
      const error = 'Playlist item not found';
      throw error;
    }
  },
  async save({ state }) {
    const response = await playlistService.update(state.playlist._id, state.playlist);
    return response.data;
  },
  async create({ commit }, playlist) {
    const response = await playlistService.create(playlist);
    commit('setPlaylist', response.data.playlist);
    return response.data.playlist;
  }
};

export default {
  namespaced: true,
  state: playlistState,
  getters: playlistGetters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/vuex/modules/playlist.js